import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Hook do pobierania danych dla wielu drużyn jednocześnie.
 * @param {Array} selectedTeams - Lista wybranych drużyn z kolorami.
 * @param {Function} getUrl - Funkcja przyjmująca teamId i zwracająca ścieżkę API.
 * @param {Object} params - Dodatkowe parametry query (opcjonalne).
 * @param {Boolean} enabled - Czy pobieranie jest aktywne (np. walidacja pól).
 */
const useChartData = (selectedTeams, getUrl, params = {}, enabled = true) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Jeśli brak drużyn lub pobieranie wyłączone - czyścimy dane
    if (!enabled || selectedTeams.length === 0) {
      setData([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const requests = selectedTeams.map(team =>
          axios.get(`${process.env.REACT_APP_API_URL}${getUrl(team.teamId)}`, { params })
        );
        
        const responses = await Promise.all(requests);
        
        // Zwracamy surowe dane wraz z metadanymi drużyny (nazwa, kolor)
        const results = responses.map((res, index) => ({
          team: selectedTeams[index],
          rawData: res.data
        }));
        
        setData(results);
      } catch (err) {
        setError("Błąd pobierania danych z serwera.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // JSON.stringify(params) pozwala reagować na zmiany wewnątrz obiektu parametrów
  }, [selectedTeams, enabled, JSON.stringify(params)]);

  return { data, loading, error };
};

export default useChartData;